module.exports = __webpack_public_path__ + "img/gaa.210fe3d9.svg";